"use client";
import { jsx as t } from "react/jsx-runtime";
import { s as n } from "../../Author.module-DO0Qr1K7.mjs";
const i = ({ company: e, url: r, testId: a }) => /* @__PURE__ */ t("a", { href: r, target: "_blank", rel: "noopener noreferrer", className: n.companyLink, "aria-label": e, "data-testid": a, children: e });
export {
  i as CompanyLink
};
//# sourceMappingURL=CompanyLink.es.js.map
